export default "/images/icon-ai-search.gif?c83fc6484ff2985c9efe184879c172f3";